<template>
  <span
    class="ribbon"
    :class="[`ribbon--tone-${tone}`, `ribbon--${size}`, { 'ribbon--hollow': hollow }]"
    :style="{ '--fill': `${fill}%` }"
    aria-hidden="true"
  >
    <span class="ribbon__fill"></span>
  </span>
</template>

<script>
// The bookmark ribbon that identifies a catalog in a comparison. The three
// slots take the three stops of the brand gradient (purple, pink, orange), and
// the same ribbon marks that catalog's shelf tab, its grid column and every
// page it's cited on. `fill` (0–100) shows reading progress; `hollow` is an
// empty slot waiting for a catalog.
export default {
  name: "CatalogRibbon",
  props: {
    tone: { type: Number, default: 0 }, // 0 purple, 1 pink, 2 orange
    fill: { type: Number, default: 100 },
    size: { type: String, default: "md" }, // sm | md | lg
    hollow: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.ribbon {
  --w: 10px;
  --h: 16px;
  position: relative;
  display: inline-block;
  flex: none;
  width: var(--w);
  height: var(--h);
  /* Swallowtail notch at the foot, like a bound-in bookmark. */
  clip-path: polygon(0 0, 100% 0, 100% 100%, 50% 74%, 0 100%);
  background: color-mix(in oklab, var(--slot) 18%, var(--paper));
  overflow: hidden;
}
.ribbon--sm {
  --w: 7px;
  --h: 11px;
}
.ribbon--lg {
  --w: 14px;
  --h: 26px;
}
.ribbon__fill {
  position: absolute;
  inset: 0 0 auto 0;
  height: var(--fill);
  background: var(--slot);
  transition: height 240ms ease-out;
}
.ribbon--hollow {
  background: transparent;
  box-shadow: inset 0 0 0 1.5px var(--slot);
}
.ribbon--hollow .ribbon__fill {
  display: none;
}
.ribbon--tone-0 {
  --slot: var(--brand-purple);
}
.ribbon--tone-1 {
  --slot: var(--brand-pink);
}
.ribbon--tone-2 {
  --slot: var(--brand-orange);
}
@media (prefers-reduced-motion: reduce) {
  .ribbon__fill {
    transition: none;
  }
}
</style>
